import React, { Component, createRef } from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Info from '@material-ui/icons/Info';
import Work from '@material-ui/icons/Work';
import LocalPhone from '@material-ui/icons/LocalPhone';
import WhereToVote from '@material-ui/icons/WhereToVote';
import PersonOutline from '@material-ui/icons/PersonOutline';
import AccountBalance from '@material-ui/icons/AccountBalance';
import SingleBed from '@material-ui/icons/SingleBed';
import classNames from 'classnames';

import './Review.css';

const style = (theme) => ({
  infoArea: {
    maxWidth: '360px',
    margin: '0 auto',
    padding: '0px',
    textAlign: 'center',
  },
  iconWrapper: {
    float: 'left',
    marginTop: '24px',
    marginRight: '10px',
  },
  // primary: {
  //   color: primaryColor
  // },
  // warning: {
  //   color: warningColor
  // },
  // danger: {
  //   color: dangerColor
  // },
  success: {
    color: '#4caf50',
  },
  // info: {
  //   color: infoColor
  // },
  // rose: {
  //   color: roseColor
  // },
  // gray: {
  //   color: grayColor
  // },
  icon: {
    width: '36px',
    height: '36px',
  },
  descriptionWrapper: {
    // color: grayColor,
    overflow: 'hidden',
  },
  title: {
    color: '#3C4858',
    margin: '1.75rem 0 0.875rem !important',
    marginTop: '30px',
    minHeight: 'unset',
    // font-family: "Roboto Slab", "Times New Roman", serif;
    fontWeight: 700,
    marginBottom: '25px',
    textDecoration: 'none',
  },
  description: {
    // color: grayColor,
    overflow: 'hidden',
    marginTop: '0px',
    fontSize: '14px',
  },
  iconWrapperVertical: {
    float: 'none',
  },
  iconVertical: {
    width: '61px',
    height: '61px',
  },

  infoSection: {
    width: '90%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  infoConteyner: {
    borderRadius: '30px',
    background: '#FFF',
    boxShadow: '0px 0px 10px 0px rgba(49, 40, 63, 0.10)',
    width: '30%',
    padding: '5px 15px 35px',
    textAlign: 'left',
    overflow: 'hidden',
    maxHeight: '342px',
    position: 'relative',
    margin: '15px 0',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  infoTitle: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#0A0A13',
    whitespace: 'nowrap',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '130%',
  },
  infoDescription: {
    overflow: 'hidden',
    color: '#0A0A13',
    textOverflow: 'ellipsis',
    whitespace: 'nowrap',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '130%',
  },
  expanded: {
    maxHeight: 'none',
    borderRadius: '30px',
    background: '#FFF',
    boxShadow: '0px 0px 10px 0px rgba(49, 40, 63, 0.10)',
    width: '30%',
    padding: '10px 15px',
    textAlign: 'left',
    overflow: 'hidden',
  },
  textButton: {
    position: 'absolute',
    right: '15px',
    bottom: '-3px',
    color: '#595959',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '130%',
    textDecorationLine: 'underline',
    cursor: 'pointer',
  },
  test: {
    display: 'flex',
  },
});
class ResortServices extends Component {
  state = {
    data: {},
    resortName: '',
    resortType: '',
    resortSсhedule: '',
    resortBeds: '',
    resortPricePerDay: '',
    resortPeriods: '',
    resortCertificationResult: '',
    resortCertificationDate: '',
    resortLicense: [],
    resortCode: '',
    yearEstablishment: '',
    specialTerritory: '',
    directorSuName: '',
    directorName: '',
    directorFatherName: '',
    ownerSurname: '',
    ownerName: '',
    ownerFatherName: '',
    ownerId: '',
    ownerTitle: '',
    ownerCode: '',
    formOfOwner: '',
    childrenAccess: '',
    ListOfProperties: '',
    ownerIndex: '',
    ownerCountry: '',
    ownwerRegion: '',
    ownerDistrict: '',
    ownerCity: '',
    ownerStreet: '',
    ownerHouse: '',
    ownerTel: '',
    ownerMobTel: '',
    ownerFax: '',
    ownerWeb: '',
    ownerEmail: '',
    testText: 1,
    n_verified: '',
    c_verified_text: '',
    number_id: '',
    isExpanded: false,
  }

  textRef = createRef();

  setIsExpanded = () => {
    if(this.state.isExpanded === false){
    this.setState({
       isExpanded: true,
    });
  } else {
    this.setState({
      isExpanded: false,
   });
   this.textRef.current.scrollIntoView({ behavior: "smooth" });
  }
  }

  static getDerivedStateFromProps(props, state) {
    return {

      resortName: props.mapMo.P_3,
      resortSсhedule: props.mapMo.P_22,
      resortBeds: props.mapMo.P_26,
      resortPricePerDay: props.mapMo.P_27,
      resortPeriods: props.mapMo.P_28,
      resortCertificationResult: props.mapMo.P_23,
      resortCertificationDate: props.mapMo.P_24,
      resortLicense: props.lics,
      resortCode: props.mapMo.P_48,
      resortType: props.mapMo.P_21,
      yearEstablishment: props.mapMo.P_15,
      specialTerritory: props.mapMo.P_25,
      directorSuName: props.mapMo.P_18,
      directorName: props.mapMo.P_19,
      directorFatherName: props.mapMo.P_20,
      ownerSurname: props.mapMo.P_31,
      ownerName: props.mapMo.P_32,
      ownerFatherName: props.mapMo.P_33,
      ownerId: props.mapMo.P_34,
      ownerTitle: props.mapMo.P_29,
      ownerCode: props.mapMo.P_30,
      formOfOwner: props.mapMo.P_16,
      childrenAccess: props.mapMo.P_52,
      ListOfProperties: props.mapMo.P_35,
      ownerIndex: props.mapMo.P_36,
      ownerCountry: props.mapMo.P_37,
      ownwerRegion: props.mapMo.P_38,
      ownerDistrict: props.mapMo.P_39,
      ownerCity: props.mapMo.P_40,
      ownerStreet: props.mapMo.P_41,
      ownerHouse: props.mapMo.P_42,
      ownerTel: props.mapMo.P_43,
      ownerMobTel: props.mapMo.P_44,
      ownerFax: props.mapMo.P_45,
      ownerWeb: props.mapMo.P_46,
      ownerEmail: props.mapMo.P_47,
      n_verified: props.mapMo.P_50,
      c_verified_text: props.mapMo.P_51,
      number_id: props.mapMo.P_49,

    };
  }

  render() {
    const { classes } = this.props;
    // console.log(this.state.data)
    // const date = new Date(this.state.resortCertificationDate);
    //             const monthNames = [
    //               "Січня",
    //               "Лютого",
    //               "Березня",
    //               "Квітня",
    //               "Травня",
    //               "Червня",
    //               "Липня",
    //               "Серпня",
    //               "Вересня",
    //               "Жовтня",
    //               "Листопада",
    //               "Грудня"
    //             ];
    //             const day = date.getDate();
    //             const month = date.getMonth();
    //             const year = date.getFullYear();
    //             const dateCertification = `${day} ${
    //               monthNames[month]
    //             } ${year}р.`
    const iconWrapper = classNames({
      [classes.iconWrapper]: true,
      [classes.success]: true,
      [classes.iconWrapperVertical]: true,
    });
    const iconClasses = classNames({
      [classes.icon]: true,
      [classes.iconVertical]: true,
    });
    return (
      <div className="container-fluid resortInfo">
  <div className={classes.infoSection}>        
<div className={` ${classes.infoConteyner} ${this.state.isExpanded === true ? classes.expanded : ''} `}>
    <p ref={this.textRef} className={classes.title}>Інформація про заклад</p>
    <p className={classes.infoTitle}>Номер в Реєстрі:<span className={classes.infoDescription}>{this.state.number_id}</span></p>
    <p className={classes.infoTitle}>Код ЄДРПОУ: <span className={classes.infoDescription}>{this.state.resortCode}</span> </p>
    <p className={classes.infoTitle}>Рік заснування: <span className={classes.infoDescription}>{this.state.yearEstablishment}</span> </p>
    <p className={classes.infoTitle}>Спеціально відведена територія: <span className={classes.infoDescription}>{this.state.specialTerritory}</span> </p>
    <p className={classes.infoTitle}>Форма власності: <span className={classes.infoDescription}>{this.state.formOfOwner}</span> </p>
    <p className={classes.infoTitle}>Доступність для дітей з інвалідністю: <span className={classes.infoDescription}>{this.state.childrenAccess}</span> </p>
    <p className={classes.infoTitle}>Перелік об'єктів закладу: </p>
    <p onClick={this.setIsExpanded} className={classes.textButton}>
        {this.state.isExpanded ? "Згорнути" : "Розгорнути"}
      </p>
      {this.state.isExpanded === true ?
     <div>
     <span className={classes.infoDescription}>{this.state.ListOfProperties}</span> 
    
     <p className={classes.infoTitle}>Керівник: 
     <span className={classes.infoDescription}>
      {this.state.directorSuName}
      {' '}
       {this.state.directorName}
       {' '}
       {this.state.directorFatherName}
      </span> </p>
     </div>
    : null }
</div>

<div className={classes.infoConteyner}>
    <p className={classes.title}>Характеристика послуг</p>
    <p className={classes.infoTitle}>Режим роботи:<span className={classes.infoDescription}>{this.state.resortSсhedule}</span></p>
    <p className={classes.infoTitle}>Тип закладу: <span className={classes.infoDescription}>{this.state.resortType}</span> </p>
    <p className={classes.infoTitle}>Кількість ліжко-місць: <span className={classes.infoDescription}>{this.state.resortBeds}</span> </p>
    <p className={classes.infoTitle}>Вартість ліжко-дня: <span className={classes.infoDescription}>{this.state.resortPricePerDay}грн.</span> </p>
    <p className={classes.infoTitle}>Графік змін: <span className={classes.infoDescription}>{this.state.resortPeriods}</span> </p>
</div>

<div className={classes.infoConteyner}>
    <p className={classes.title}>Державна атестація</p>
    <p className={classes.infoTitle}>Дата проведення:<span className={classes.infoDescription}>{this.state.resortCertificationDate !== null && moment(this.state.resortCertificationDate).format('DD.MM.YYYY')}{' '}</span></p>
    <p className={classes.infoTitle}>Результат: <span className={classes.infoDescription}>{this.state.resortCertificationResult}</span> </p>
</div>

<div className={classes.infoConteyner}>
    <p className={classes.title}>Ліцензії:</p>
    <span className={classes.infoTitle}>
                  {this.state.resortLicense.map((lic) => (
                    <div className="container-fluid" key={lic.number}>
                      <div className="row">
                        <div className="col-12 ">
                          <strong>
                            {' '}
                            <em>Назва:</em>
                          </strong>
                          {' '}
                          {lic.licenseName}
                        </div>
                        <div className="col-12">
                          <strong>Номер:</strong>
                          {' '}
                          {lic.number}
                        </div>
                        <div className="col-12 ">
                          <strong>Серия:</strong>
                          {' '}
                          {lic.serie}
                        </div>
                        <div className="col-12 ">
                          <strong>Дата:</strong>
                          {' '}
                          {lic.issued !== null && moment(lic.issued).format('DD.MM.YYYY')}
                        </div>
                        <div className="col-12 ">
                          <strong>Строк дії:</strong>
                          {' '}
                          {lic.till === '' ? null : moment(lic.till).format('DD.MM.YYYY')}
                        </div>
                        <div className="col-12 mb-4">
                          <strong>Ким видана:</strong>
                          {' '}
                          {lic.whogave}
                        </div>
                      </div>
                    </div>
                  ))}
                </span>
</div>

{this.state.ownerTitle !== null
          && (
<div className={classes.infoConteyner}>
    <p className={classes.title}>Власник (юридична особа)</p>
    <p className={classes.infoTitle}>Найменування:<span className={classes.infoDescription}>{this.state.ownerTitle}</span></p>
    <p className={classes.infoTitle}>Код ЄДРПОУ: <span className={classes.infoDescription}>{this.state.ownerCode}</span> </p>
</div>
) }
{this.state.ownerSurname !== null && (
<div className={classes.infoConteyner}>
    <p className={classes.title}>Власник (фізична особа)</p>
    <p className={classes.infoTitle}>ПІБ:<span className={classes.infoDescription}>
                  {this.state.ownerSurname}
                  {' '}
                  {this.state.ownerName}
                  {' '}
                  {this.state.ownerFatherName}</span></p>
    <p className={classes.infoTitle}>Код ДРФО: <span className={classes.infoDescription}>{this.state.ownerId}</span> </p>
</div>
) }

<div className={classes.infoConteyner}>
    <p className={classes.title}>Адреса власника</p>
    <p className={classes.infoTitle}>Поштовий індекс:<span className={classes.infoDescription}>{this.state.ownerIndex}</span></p>
    <p className={classes.infoTitle}>Країна: <span className={classes.infoDescription}>{this.state.ownerCountry}</span> </p>
    <p className={classes.infoTitle}>Область: <span className={classes.infoDescription}>{this.state.ownwerRegion}</span> </p>
    <p className={classes.infoTitle}>Район: <span className={classes.infoDescription}>{this.state.ownerDistrict}</span> </p>
    <p className={classes.infoTitle}>Населений пункт: <span className={classes.infoDescription}>{this.state.ownerCity}</span> </p>
    <p className={classes.infoTitle}>Вулиця: <span className={classes.infoDescription}>{this.state.ownerStreet}</span> </p>
    <p className={classes.infoTitle}>Номер будинку: <span className={classes.infoDescription}>{this.state.ownerHouse}</span> </p>
</div>

<div className={classes.infoConteyner}>
    <p className={classes.title}>Контакти власника</p>
    <p className={classes.infoTitle}>Стаціонарний номер телефону:<span className={classes.infoDescription}>{this.state.ownerTel}</span></p>
    <p className={classes.infoTitle}>Мобільний номер телефону: <span className={classes.infoDescription}>{this.state.ownerMobTel}</span> </p>
    <p className={classes.infoTitle}>Номер телефаксу: <span className={classes.infoDescription}>{this.state.ownerFax}</span> </p>
    <p className={classes.infoTitle}>Адреса веб-сайту: <span className={classes.infoDescription}>{this.state.ownerWeb}</span> </p>
    <p className={classes.infoTitle}>Населений пункт: <span className={classes.infoDescription}>{this.state.ownerCity}</span> </p>
    <p className={classes.infoTitle}>Вулиця: <span className={classes.infoDescription}>{this.state.ownerStreet}</span> </p>
    <p className={classes.infoTitle}>Номер будинку: <span className={classes.infoDescription}>{this.state.ownerHouse}</span> </p>
</div>

</div>


        <div className="row smallText mt-2">


          {/* <div className="col-12">
            <NavLink
              to="/mop/search"
              style={{ textDecoration: 'none' }}
              activeStyle={{
                border: '1px solid #fff',
              }}
            >
              <span
                className="btn btn-primary btn-md btn-search mb-3"
                role="button"
              >
                Назад до пошуку
              </span>
            </NavLink>

          </div> */}
        </div>
      </div>
    );
  }
}

ResortServices.propTypes = {

};

export default withStyles(style)(ResortServices);
